declare global {
  interface Window {
    __organicLayoutPreload?: Promise<unknown>;
    __organicLayoutPreloadVariant?: string;
    __organicLayoutPreloadReason?: string;
    __organicLayoutPreloadSource?: 'cms' | 'local';
  }
}

export const getLayoutPreload = (variant = 'default'): Promise<unknown> | undefined =>
  typeof window === 'undefined' || window.__organicLayoutPreloadVariant !== variant
    ? undefined
    : window.__organicLayoutPreload;
